import { useEffect } from 'react'

import { Box, Button, HStack, Stack, Text } from '@chakra-ui/react'
import {
  StaticScreen,
  StaticScreenContent,
  StaticScreenTitle,
} from 'src/components/StaticScreen/StaticScreen'
import { useVideoCallRoom } from 'src/features/videoCall/context/videoCallRoomContext'
// eslint-disable-next-line no-restricted-imports -- legacy_modulesを削除できるまで無効化（認証周りをリニューアルしたい）
import { useLogout } from 'src/legacy_modules/auth/logout/use-logout'

type Props = {
  isLeft?: boolean
  shouldLogout: boolean
  returnUrl?: string
}

/** 退出or終了した場合に表示する画面 */
export const ExplanationRoomFinished: React.FC<Props> = ({
  isLeft,
  shouldLogout,
  returnUrl,
}) => {
  const { handleLogout } = useLogout()

  const { leave } = useVideoCallRoom()

  useEffect(() => {
    leave()
  }, [leave])

  return (
    <StaticScreen colorScheme="green">
      <StaticScreenTitle>
        {isLeft ? '面談から退出しました。' : '説明は終了しました。'}
      </StaticScreenTitle>
      <StaticScreenContent>
        {shouldLogout ? (
          <Stack spacing="8">
            <Text>再度ログインする場合は以下のボタンを押してください。</Text>
            <HStack spacing="8" justify="center">
              {isLeft && !!returnUrl && (
                <Button
                  colorScheme="green"
                  w="200px"
                  variant="outline"
                  onClick={() => {
                    window.location.href = returnUrl
                  }}
                >
                  面談に戻る
                </Button>
              )}
              <Button colorScheme="green" w="200px" onClick={handleLogout}>
                ログイン画面へ戻る
              </Button>
            </HStack>
          </Stack>
        ) : (
          <Stack spacing="14">
            <Text>ブラウザのタブを閉じてください。</Text>
            {isLeft && !!returnUrl && (
              <Box>
                <Button
                  w="200px"
                  colorScheme="green"
                  variant="outline"
                  onClick={() => {
                    window.location.href = returnUrl
                  }}
                >
                  面談に戻る
                </Button>
              </Box>
            )}
          </Stack>
        )}
      </StaticScreenContent>
    </StaticScreen>
  )
}
